import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffGraduationsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      staff_list: [],
      aircraft_model_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionarios/graduacao/ativos', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_model_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista de tripulantes */ });
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      aircraft_model_id: this.state.aircraft_model_id,
      graduation: this.state.graduation,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/graduacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData();
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.deletarRegistro);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/graduacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <h4>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tituloAdicionarGraduacao}</h4>
        <hr/>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.Tripulante}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.placeholder.SelecioneOTripulante}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                />    
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.Frota}:</label>
                <Select
                  className="form-field-name"
                  name="aircraft_model_id"
                  value={this.state.aircraft_model_id}
                  searchable={true}
                  placeholder={this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.placeholder.SelecioneAFrota}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                  options={this.state.aircraft_model_list}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.Graduacao}:</label>
                <Select
                  className="form-field-name"
                  name="graduation"
                  value={this.state.graduation}
                  searchable={true}
                  placeholder={this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.placeholder.SelecioneAGraduacao}
                  onChange={this.handleSelectChange.bind(this, 'graduation')}
                  options={[
                    {value: 1, label: this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.opcoesGraduacao.Vermelho},
                    {value: 2, label: this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.opcoesGraduacao.Amarelo},
                    {value: 3, label: this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.opcoesGraduacao.Verde},
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.formulario.botaoAdicionarGraduacao}</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.semGraduacoes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="graduation_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.Graduacao}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='60'>{this.locale.Graduacoes.ListaDeGraduacoesDeTripulantes.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffGraduationsIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffGraduations/StaffGraduationsIndex.js